export default __webpack_public_path__ + "static/media/logo-by-qualificar.4ddbed05.png";